module.exports = __webpack_public_path__ + "static/media/rayo.a11e9d71.svg";